<dx-data-grid
  #metricDataGrid
  (onCellPrepared)="onCellPreparedSwapSaveIcon($event)"
  (onEditCanceled)="onEditCanceled()"
  (onEditingStart)="onEditingStart($event)"
  (onEditorPreparing)="onEditorPreparingMetric($event)"
  (onInitNewRow)="onInitNewRow($event)"
  (onOptionChanged)="onOptionChanged()"
  (onRowRemoved)="onRowRemoved()"
  (onRowValidating)="onRowValidatingMetric($event)"
  (onSaved)="onRowSaved()"
  (onToolbarPreparing)="editMetricAddRowButton($event)"
  keyExpr="_uiKey"
  [appRowStateHighlight]="rowStateTracker"
  [appRowStateScope]="rowStateScope"
  [loadPanel]="{enabled: false}"
  [dataSource]="metrics"
  [showBorders]="true"
  [showRowLines]="false"
  [wordWrapEnabled]="false"
  [columnResizingMode]="'widget'"
  [allowColumnResizing]="true"
  noDataText="{{ emptyMessageKey | translate }}"
  height="100%"
  style="min-width: 100%;">

  <dxo-toolbar>
    <dxi-item location="before">
      <div style="line-height: 1.2;">
        <p style="font-size: 20px; margin: 0; white-space: nowrap;">{{ 'REGISTRY.DEVICE.TABLES.METRICS' | translate }}{{ titleSuffix ? ' ' + titleSuffix : '' }}<app-row-state-badge *ngIf="editable" [trackers]="[rowStateTracker]" [scoped]="true" [scope]="rowStateScope"></app-row-state-badge></p>
        <p *ngIf="groupName" title="{{ groupName }}" style="font-size: 13px; margin: 0; max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: var(--dx-color-secondary-text, gray);">{{ groupName }}</p>
      </div>
    </dxi-item>
    <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel"></dxi-item>
    <dxi-item *ngIf="showAction" location="before">
      <dx-button
        [disabled]="!hasAddableMetrics"
        [text]="'REGISTRY.DEVICE.TEMPLATE_IMPORT.ADD_ALL' | translate"
        icon="add"
        stylingMode="text"
        type="default"
        (onClick)="onAddAllClick()">
      </dx-button>
    </dxi-item>
    <dxi-item *ngIf="showCsvImportExport && editable && showToolbarActions" location="before">
      <div *dxTemplate>
        <dx-button
          [hint]="translate.instant('BUTTONS.HINTS.IMPORT')"
          icon="import"
          stylingMode="text"
          (click)="triggerFileSelection()">
        </dx-button>
        <input
          type="file"
          accept="application/vnd.ms-excel, text/csv"
          style="display: none"
          #fileInput
          (change)="onFileSelected($event)">
      </div>
    </dxi-item>
    <dxi-item *ngIf="showCsvImportExport && showToolbarActions" location="before">
      <div *dxTemplate>
        <dx-button
          [hint]="translate.instant('BUTTONS.HINTS.EXPORT')"
          (onClick)="objectsToCSV(metrics)"
          icon="download"
          stylingMode="text">
        </dx-button>
      </div>
    </dxi-item>
    <dxi-item *ngIf="editable && showToolbarActions" locateInMenu="never" location="before" name="addRowButton" showText="inMenu"></dxi-item>
  </dxo-toolbar>

  <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}"></dxo-search-panel>
  <dxo-paging [enabled]="true" [pageSize]="50"></dxo-paging>
  <dxo-scrolling mode="virtual" showScrollbar="onScroll"></dxo-scrolling>
  <dxo-selection [mode]="editable ? 'single' : 'none'"></dxo-selection>

  <dxo-editing
    [allowAdding]="editable && showToolbarActions"
    [allowDeleting]="editable && showDeleteRowButton"
    [allowUpdating]="editable"
    [newRowPosition]="'last'"
    [useIcons]="true"
    mode="row">
    <dxo-texts
      cancelRowChanges="{{'BUTTONS.CANCEL' | translate}}"
      deleteRow="{{'BUTTONS.DELETE' | translate}}"
      editRow="{{'BUTTONS.UPDATE' | translate}}"
      saveRowChanges="{{'BUTTONS.CONFIRM' | translate}}">
    </dxo-texts>
  </dxo-editing>

  <dxi-column [visible]="false" sortOrder="asc" [sortIndex]="1" dataField="id"></dxi-column>

  <dxi-column
    *ngIf="!showAction && showActiveColumn"
    [width]="120"
    [minWidth]="20"
    alignment="center"
    caption="{{'REGISTRY.DEVICE.METRIC.ACTIVE' | translate}}"
    cellTemplate="selectedCell">
    <div *dxTemplate="let metric of 'selectedCell'" class="flexRow" style="justify-content: center;">
      <dx-check-box
        [disabled]="!editable"
        [value]="metric.data.selected !== false"
        (onValueChanged)="$event.event && onMetricSelectedChanged(metric.data, $event.value)">
      </dx-check-box>
    </div>
  </dxi-column>

  <dxi-column
    *ngIf="showSyncStatus"
    [width]="50"
    [minWidth]="20"
    caption=""
    cellTemplate="syncCell">
    <div *dxTemplate="let metric of 'syncCell'">
      <i [title]="metric.data.syncStatus" [class]="getSyncIcon(metric.data.syncStatus) + ' syncStatusIcon'"></i>
    </div>
  </dxi-column>

  <dxi-column caption="{{'REGISTRY.DEVICE.METRIC.NAME' | translate}}" dataField="name" [minWidth]="20" [width]="180">
    <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                         [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                         type="stringLength"></dxi-validation-rule>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    *ngIf="showRawTransportColumns"
    caption="{{'REGISTRY.DEVICE_TYPE.METRIC.ADDRESS' | translate}}"
    dataField="transportConfiguration.address"
    dataType="number"
    sortOrder="asc"
    [sortIndex]="0"
    [width]="120"
    [minWidth]="20">
    <dxi-validation-rule type="required" message="{{'COMMON.IS_REQUIRED' | translate}}"></dxi-validation-rule>
    <dxi-validation-rule type="range" [min]="0" [max]="65535"
                         message="{{'ERROR.NUMBER_OVER_LIMIT' | translate: {min: '0', max:'65535'} }}"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    [editorOptions]="{disabled: dataTypeColumnReadOnly}"
    caption="{{'REGISTRY.DEVICE_TYPE.METRIC.DATA_TYPE' | translate}}"
    dataField="transportConfiguration.dataType"
    [setCellValue]="setCellValueDataType"
    [width]="150"
    [minWidth]="20">
    <dxo-lookup
      [dataSource]="getFilteredDataTypeValues()"
      displayExpr="label"
      valueExpr="value">
    </dxo-lookup>
    <dxi-validation-rule type="required" message="{{'COMMON.IS_REQUIRED' | translate}}"></dxi-validation-rule>
  </dxi-column>

  <dxi-column [width]="'125'"
              [minWidth]="20"
              *ngIf="showRawTransportColumns"
              caption="{{'REGISTRY.DEVICE_TYPE.METRIC.BIT_POSITION' | translate}}"
              dataField="transportConfiguration.bitPosition"
              dataType="number">
    <dxi-validation-rule [validationCallback]="validateBit" message="{{ 'COMMON.IS_INVALID' | translate }}"
                         type="custom"></dxi-validation-rule>
    <dxi-validation-rule type="range" [min]="0"></dxi-validation-rule>
  </dxi-column>

  <dxi-column [width]="'175'"
              [minWidth]="20"
              *ngIf="showRawTransportColumns"
              caption="{{'REGISTRY.DEVICE_TYPE.METRIC.BYTE_ORDER' | translate}}"
              dataField="transportConfiguration.byteOrder">
    <dxo-lookup
      [dataSource]="gmService.byteOrderValues"
      displayExpr="label"
      valueExpr="value">
    </dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column [width]="'100'"
              [minWidth]="20"
              caption="{{'REGISTRY.DEVICE_TYPE.METRIC.DIVIDER' | translate}}"
              dataField="divider"
              dataType="number">
    <dxi-validation-rule [validationCallback]="validateDivider" message="{{ 'COMMON.IS_REQUIRED' | translate }}"
                         type="custom"></dxi-validation-rule>
    <dxi-validation-rule [validationCallback]="dividerRange"
                         message="{{'REGISTRY.DEVICE_TYPE.VALIDATION.DIVIDER' | translate}}"
                         type="custom"></dxi-validation-rule>
  </dxi-column>

  <dxi-column [width]="100"
              [minWidth]="20"
              caption="{{'REGISTRY.DEVICE.METRIC.DATA_UNIT' | translate}}"
              dataField="dataUnitId">
    <dxo-lookup
      [dataSource]="dataUnitValues"
      displayExpr="name"
      valueExpr="id">
    </dxo-lookup>
  </dxi-column>

  <dxi-column [editorOptions]="{ format: '#0', min: 0}" [width]="'100'"
              [minWidth]="20"
              caption="{{'REGISTRY.DEVICE_TYPE.METRIC.DECIMAL_DIGITS' | translate}}"
              dataField="decimalDigits"
              dataType="number">
    <dxi-validation-rule [max]="gmService.DECIMAL_DIGITS_MAX" [min]="gmService.DECIMAL_DIGITS_MIN" type="range"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    [showEditorAlways]="rowIsBeingEdited"
    *ngIf="showWm2eColumns"
    caption="{{'REGISTRY.DEVICE.METRIC.ORIGIN_TYPE' | translate}}"
    dataField="wm2eOriginType"
    [setCellValue]="setCellValueWm2eOriginType"
    [width]="150"
    [minWidth]="20">
    <dxo-lookup
      [dataSource]="gmService.writeOnEdgeOriginTypeValues"
      displayExpr="label"
      valueExpr="value">
    </dxo-lookup>
  </dxi-column>
  <dxi-column
    *ngIf="showWm2eColumns"
    caption="{{'REGISTRY.DEVICE.METRIC.ORIGIN_METRIC' | translate}}"
    [showEditorAlways]="true"
    editCellTemplate="originMetricSelector"
    [width]="220"
    [minWidth]="20"
    dataField="wm2eOriginId">
    <div *dxTemplate="let item of 'originMetricSelector'" class="flexRow">
      <ng-container *ngIf="item.data.wm2eOriginType === WriteOnEdgeOriginTypeEnum.SYSTEM">
        <dx-button
          class="smallButton"
          stylingMode="text"
          *ngIf="rowIsBeingEdited"
          type="default"
          (onClick)="$event!.event!.stopPropagation();
                              selectedRowReference = item;
                              pairingMetric = true;
                              item.data.showInvalidBadge = false">
          <i *ngIf="!item.data.wm2eOriginId" class="vf-ic_fluent_link_24_filled"></i>
          <i *ngIf="item.data.wm2eOriginId" class="vf-ic_fluent_link_edit_24_filled"></i>
        </dx-button>
        <span
          class="originMetricLabel"
          [title]="getSelectedMetricLabel(item.data.wm2eOrigin) ?? '---'">{{ getSelectedMetricLabel(item.data.wm2eOrigin) ?? '---' }}</span>
        <div *ngIf="item.data.showInvalidBadge" class="invalidBadge">!</div>
      </ng-container>
    </div>
  </dxi-column>

  <dxi-column
    *ngIf="showAction"
    [width]="60"
    [minWidth]="20"
    [fixed]="true"
    fixedPosition="right"
    caption=""
    cellTemplate="actionCell">
    <div *dxTemplate="let metric of 'actionCell'" class="flexRow" style="justify-content: center;">
      <i
        *ngIf="metric.data.action !== CompareActionEnum.REPLACE"
        (click)="metric.data.action === CompareActionEnum.ADD && onAddClick($event, metric.data)"
        [class.custom-action-icon-disabled]="metric.data.action !== CompareActionEnum.ADD"
        class="dx-icon-add custom-action-icon"></i>
      <i
        *ngIf="metric.data.action === CompareActionEnum.REPLACE"
        (click)="onReplaceClick($event, metric.data)"
        title="{{'REGISTRY.DEVICE.TEMPLATE_IMPORT.REPLACE' | translate}}"
        class="dx-icon-arrowright custom-action-icon-danger"></i>
    </div>
  </dxi-column>

  <dxi-column
    *ngIf="editable"
    type="buttons"
    [width]="100"
    [minWidth]="20"
    [fixed]="true"
    fixedPosition="right"
    [buttons]="['edit', 'delete']">
  </dxi-column>

  <dxi-column
    *ngIf="showDelete"
    [width]="60"
    [minWidth]="20"
    [fixed]="true"
    fixedPosition="right"
    cellTemplate="deleteCell"
    caption="">
    <div *dxTemplate="let metric of 'deleteCell'" class="flexRow" style="justify-content: center;">
      <i (click)="onDeleteClick($event, metric.data)" class="dx-icon-trash custom-action-icon"></i>
    </div>
  </dxi-column>

</dx-data-grid>

<dx-popup
  [(visible)]="pairingMetric"
  (onHiding)="metricSelectorComponent.resetSelectedMetrics()"
  [dragEnabled]="false"
  [focusStateEnabled]="true"
  [hideOnOutsideClick]="false"
  [fullScreen]="appService.isSmallScreen()"
  [showCloseButton]="true"
  [showTitle]="true"
  [title]="'REGISTRY.DEVICE.TEXT.PAIR_METRIC' | translate">
  <div style="display: flex; gap: 10px; flex-direction: column; height: 100%">
    <app-partition-selector
      style="flex: 0 1 0;"
      [(selectedPartition)]="dashboardService.selectedPartitionIds[0]">
    </app-partition-selector>
    <div class="sideBySideLists" style="flex: 1 1 0; height: 0;">
      <app-device-selector
        #deviceSelectorComponent
        [(selectedDeviceId)]="dashboardService.selectedDeviceIds[0]"
        [selectedPartitionId]="dashboardService.selectedPartitionIds[0]"
        class="flexFill">
      </app-device-selector>
      <app-metric-selector
        #metricSelectorComponent
        (selectedMetricsChange)="metricsSelected($event);"
        [deviceList]="deviceSelectorComponent.deviceList"
        [inputDisplayMode]="'table'"
        [isDataForChart]="false"
        [forbidWriteable]="true"
        [forbiddenDataTypes]="getSelectableDataTypeGroups()"
        [selectedDeviceId]="dashboardService.selectedDeviceIds[0]"
        [selectedPartitionId]="dashboardService.selectedPartitionIds[0]"
        class="flexFill"
        style="overflow: hidden">
      </app-metric-selector>
    </div>
  </div>
</dx-popup>
